import { JwtAxios } from '@/packaging';

export const cafe24Api = {
  async GetCafe24Template(marketAccount) {
    const responseModel = await JwtAxios.get(
      `/Template/Market/GetCafe24Template?marketAccount=${marketAccount}`
    );
    return responseModel;
  },
  async GetCafe24TransPolicy(body) {
    const responseModel = await JwtAxios.post(
      `/Template/Market/GetCafe24TransPolicy?connectionId=${body.connectionId}&marketAccount=${body.marketAccount}&marketIdx=${body.marketIdx}&marketSubIdx=${body.marketSubIdx}&placeNo=${body.placeNo}`
    );
    return responseModel;
  },
  async GetCafe24Shipment(connectionId, marketAccount) {
    const responseModel = await JwtAxios.post(
      `/Template/Market/GetCafe24Shipment?connectionId=${connectionId}&marketAccount=${marketAccount}`
    );
    return responseModel;
  },
  async GetCafe24ReturnExchange(connectionId, marketAccount) {
    const responseModel = await JwtAxios.post(
      `/Template/Market/GetCafe24ReturnExchange?connectionId=${connectionId}&marketAccount=${marketAccount}`
    );
    return responseModel;
  },
  async SetCafe24Template(model) {
    const responseModel = await JwtAxios.post(`/Template/Market/SetCafe24Template`, model);
    return responseModel;
  },
  async SetCafe24Account(connectionId, model) {
    const responseModel = await JwtAxios.post(
      `/Template/Market/SetCafe24Account?connectionId=${connectionId}`,
      model
    );
    return responseModel;
  }
};
